<template>
  <div class="cart-section">
    <b-dropdown
      boundary="viewport"
      lazy
      right
      offset="-100px"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
    >
      <template v-slot:button-content>
        <div class="cart-icon">
          <b-avatar
            v-if="Object.values(cartItems).length>0"
            class="badge"
          >{{Object.values(cartItems).length}}</b-avatar>
          <b-icon icon="inbox-fill"></b-icon>
        </div>
      </template>
      <div class="text-center my-1 cart-head">Tray</div>
      <hr />
      <div v-if="Object.values(cartItems).length>0" class="cart-items">
        <template v-for="(item) in cartItems">
          <div :key="'selected'+item.id" class="selected-options mb-2">
            <div @click.stop="removeItem(item)" class="cancel-wrapper">X</div>

            <ItemCard :item="item" :editable="false" />
          </div>
        </template>
        <hr />
        <div class="total d-flex justify-content-between">
          <span>Total</span>
          <span>{{cartTotal(menu.id)| currency('€')}}</span>
        </div>
        <hr />
        <Botton :onclick="checkout" buttonClass="btn btn-primary btn-round btn-md btn-block" text="Checkout" />
      </div>
      <div v-else class="empty-cart text-center">No items in your tray</div>
    </b-dropdown>
  </div>
</template>

<script>
import ItemCard from "./ItemCard";
import Botton from "../Botton";
import { mapGetters } from "vuex";
export default {
  components: {
    ItemCard,
    Botton
  },
  methods: {
    removeItem(item) {
      this.$store.commit("Cart/REMOVE_FROM_CART", {item,currentMenu:this.menu.id});
    },
    checkout(){
        this.$router.push({name:'checkout'})
    }
  },
  computed: {
    ...mapGetters({
      cartTotal: "Cart/cartTotal"
    }),
    menu() {
      return this.$store.state.MenuView.currentMenu;
    },
    cartItems() {
        if(!this.menu){
            return {}
        }
        if(!this.$store.state.Cart.cart[this.menu.id]){
            return {}
        }
        else{
            return this.$store.state.Cart.cart[this.menu.id]
        }
      
    },
  }
};
</script>

<style scoped>
.cart-section {
  position: fixed;
  z-index: 2;
  right: 10px;
  top: 5px;
  padding: 0;
}

.cart-section >>> .dropdown-menu {
  position: absolute;
  min-width: 80vw;
  top: 0px;
  left: 0px;
  will-change: transform;
  padding: 10px;
}

.cart-icon {
  color: #f96332;
  font-size: 20px;
}
.selected-options {
  position: relative;
}
.cancel-wrapper {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 16px;
  cursor: pointer;
  color: black;
  font-weight: 600;
  width: 20px;
  height: 20px;
  text-align: end;
  z-index: 5;
}
.cart-head {
  font-weight: 600;
  font-size: 16px;
}

.cart-icon {
  position: relative;
}
.badge {
  color: white;
  background: #f96332;
  width: 16px;
  font-size: 10px;
  position: absolute !important;
  top: -10px !important;
  right: 0px;
}
</style>